import React from 'react';
import { animated, useSpring } from 'react-spring';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import facetsMenuStyles from './facetsMenu.module.pcss';
import AppliedFacets from '../appliedFacets/appliedFacetsContainer';
import Facets from '../facets/facetsContainer';

export interface FacetsMenuProps {
  isFacetsDisplayed: boolean;
}

function FacetsMenu({ isFacetsDisplayed }: FacetsMenuProps): React.ReactElement {
  const { isSmall } = useMediaQuery();

  const width = useSpring({
    width: isFacetsDisplayed ? '250px' : '0px',
    config: { duration: 350, delay: isFacetsDisplayed ? 0 : 100 }
  });

  const transform = useSpring({
    transform: isFacetsDisplayed ? 'translateX(0%)' : isSmall ? 'translateX(100%)' : 'translateX(-100%)',
    config: { duration: 350 }
  });

  const opacity = useSpring({
    opacity: isFacetsDisplayed ? 1 : 0,
    config: { duration: 250 }
  });

  return (
    <animated.div style={width} className={facetsMenuStyles['facets-menu']} id="facets-menu">
      <animated.div style={{ ...transform, ...opacity }} className={facetsMenuStyles['facets-menu__facets']}>
        <AppliedFacets />
        <Facets />
      </animated.div>
    </animated.div>
  );
}

export default FacetsMenu;
